// Use .env file in the project root to set API URL
// Full manual about custom environment variables here
// https://create-react-app.dev/docs/adding-custom-environment-variables/

const url = process.env.REACT_APP_API_URL;

export default url;
